'use strict';

import ngResource from 'angular-resource';

class GlobalEventService {
  constructor($resource) {
    'ngInject';

    this.api = $resource(
      '/api/global_event/:id',
      { id: '@id' },
      {
        index: { method: 'GET', isArray: true }
      }
    );

    this.oem_api = $resource(
      '/api/oem/global_event/:id',
      { id: '@id' },
      {
        index: { method: 'GET', isArray: true },
        create: { method: 'POST', isArray: false }
      }
    );
  }
}

export default angular.module('leptonApp.GlobalEventService', ['ngResource'])
  .service('GlobalEventService', ['$resource', GlobalEventService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/global_event/global_event.service.js